import Copy from '../../../components/copy';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {confirmCashappCashoutRequest} from '../../../../reducers/app/actions';

export default ({request, button}) => {
    const dispatch = useDispatch(),
          navigate = useNavigate();
 
    return (
        <>
            <div className="page-title">Chime</div>
            <div className="page-descriptions">Read the information about your withdrawal</div>

            <div className="page-descriptions with-bg" style={{display: 'flex', gap: '10px', alignItems: 'center'}}>
                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" style={{minWidth: "25px", minHeight: "30px"}}>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15 1.25C7.40625 1.25 1.25 7.40625 1.25 15C1.25 22.5937 7.40625 28.75 15 28.75C22.5937 28.75 28.75 22.5937 28.75 15C28.75 7.40625 22.5937 1.25 15 1.25ZM14.375 7.5C14.0435 7.5 13.7255 7.6317 13.4911 7.86612C13.2567 8.10054 13.125 8.41848 13.125 8.75C13.125 9.08152 13.2567 9.39946 13.4911 9.63388C13.7255 9.8683 14.0435 10 14.375 10H15C15.3315 10 15.6495 9.8683 15.8839 9.63388C16.1183 9.39946 16.25 9.08152 16.25 8.75C16.25 8.41848 16.1183 8.10054 15.8839 7.86612C15.6495 7.6317 15.3315 7.5 15 7.5H14.375ZM12.5 12.5C12.1685 12.5 11.8505 12.6317 11.6161 12.8661C11.3817 13.1005 11.25 13.4185 11.25 13.75C11.25 14.0815 11.3817 14.3995 11.6161 14.6339C11.8505 14.8683 12.1685 15 12.5 15H13.75V18.75H12.5C12.1685 18.75 11.8505 18.8817 11.6161 19.1161C11.3817 19.3505 11.25 19.6685 11.25 20C11.25 20.3315 11.3817 20.6495 11.6161 20.8839C11.8505 21.1183 12.1685 21.25 12.5 21.25H17.5C17.8315 21.25 18.1495 21.1183 18.3839 20.8839C18.6183 20.6495 18.75 20.3315 18.75 20C18.75 19.6685 18.6183 19.3505 18.3839 19.1161C18.1495 18.8817 17.8315 18.75 17.5 18.75H16.25V13.75C16.25 13.4185 16.1183 13.1005 15.8839 12.8661C15.6495 12.6317 15.3315 12.5 15 12.5H12.5Z" fill="#3DA1FF"/>
                </svg>

                <span>Withdrawals via Chime are processed manually. The processing time takes from <b>1 min</b> to <b>48 hours</b></span>
            </div>

            <div className="cashout-receipt">
                <div className="amount">-{request.amounts.total.toFixed(2)} USD</div>
                {/* <div className="amount_cur">~{cashout_request.total_amount.usd.toFixed(2)} USD</div> */}

                <div className="receipt-data">
                    <div className="receipt-data-line">
                        <div className="title">Method</div>
                        <div className="value">Chime</div>
                    </div>
                    <div className="receipt-data-line">
                        <div className="title">Tag</div>
                        <div className="value" style={{flexDirection: 'row', gap: "10px", alignItems: 'center'}}>
                            {request.cashtag}
                            <Copy value={request.cashtag} fill="#FFFFFF" size={24} />
                        </div>
                    </div>
                </div>
            </div>

            <div className="receipt-data">
                <div className="receipt-data-line bg">
                    <div className="title">Fee</div>
                    <div className="value" style={{
                        color: 'ffffff'
                    }}>
                        {request.amounts.comission.toFixed(2)} USD
                    </div>
                </div>

                <div className="receipt-data-line bg">
                    <div className="title">Total amount</div>
                    <div className="value">
                        {request.amounts.amount.toFixed(2)} USD
                    </div>
                </div>
            </div>

            <div className="button blue" style={{
                opacity: button ? 0.7 : 1,
                cursor: button ? 'no-drop' : 'pointer'
            }} onClick={e => {
                if(button)
                    return;

                dispatch(confirmCashappCashoutRequest(request.paymentId, navigate))
            }}>{!button ? 'Confirm' : 'Please wait...'}</div>

            <div className="button" onClick={e => {
                navigate('/cashout');
            }}>Cancel</div>
        </>
    )
}